import React from "react"
import Paper from "material-ui/Paper"
import FlatButton from "material-ui/FlatButton"
import LocationExceptionInfo from "./LocationExceptionInfo"
import NearLocationsPunchMap from "../../../punch/NearLocationsPunchMap"
import strings from "../../../../localization/strings"
import ExceptionStore from "../../../../stores/ExceptionStore"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import autobind from "class-autobind"
import { ILocationException, IPunchException, EExceptionType } from "../../../../models"
import * as exceptionActions from "../../../../actions/ExceptionActions"
import { hasPermission } from "../../../../helpers/permissionHelper"
import _ from "lodash"

interface IProps {
	punchId: string
	paperHeight: number
}
interface IState {
	reviewing: boolean
	locationException: IPunchException
	exceptionRecord: ILocationException
}

export default class LocationException extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			reviewing: false,
			locationException: null,
			exceptionRecord: null
		}
		exceptionActions.loadLocationExceptionDetails(this.props.punchId)
		autobind(this)
	}

	componentWillReceiveProps(nextProps: IProps) {
		this.props.punchId !== nextProps.punchId &&
			exceptionActions.loadLocationExceptionDetails(nextProps.punchId)
	}

	componentDidMount() {
		ExceptionStore.on("change", this.changeEvent)
	}

	componentWillUnmount() {
		ExceptionStore.removeListener("change", this.changeEvent)
	}

	changeEvent() {
		const exceptionRecord = ExceptionStore.getLocationException()
		const locationException = exceptionRecord.Record.Punch.PunchExceptions.find(i => [EExceptionType.LOCATION, EExceptionType.NO_DEVICE_LOCATION, EExceptionType.MICRO_LOCATION, EExceptionType.NO_LOCATION_OR_MICROLOCATION].includes(i.TypeEnum))
		this.setState({
			exceptionRecord,
			locationException,
			reviewing: false
		})
	}

	handleReview(type: "accept" | "reject") {
		this.setState({ reviewing: true }, () => {
			const locationException = _.cloneDeep(this.state.locationException)
			if (type === "accept") {
				locationException.Approved = true
			}
			if (type === "reject") {
				locationException.Rejected = true
			}

			locationException.Reviewed = true
			exceptionActions.reviewLocException(this.props.punchId, locationException, () => {
				exceptionActions.loadLocationExceptionDetails(this.props.punchId)
			})
		})
	}

	render() {
		return (
			<div className="biometric-exception" style={{ justifyContent: "center" }}>
				{this.state.locationException &&
					<div>
						{!this.state.locationException.Approved && !this.state.locationException.Rejected &&
							hasPermission(AuthenticationStore.Permissions.PunchRecords.EditExceptions) &&
							<div style={{ position: "absolute", right: 30 }}>
								<FlatButton
									data-intercom-target={`ExceptionDialog-LocationException-${this.props.punchId}-Btn-AcceptException`}
									label={strings.ACCEPT}
									primary
									style={{ float: "right" }}
									icon={<i className="fa fa-check" />}
									disabled={this.state.reviewing}
									onClick={() => this.handleReview("accept")}
								/>
								<FlatButton
									data-intercom-target={`ExceptionDialog-LocationException-${this.props.punchId}-Btn-RejectException`}
									label={strings.REJECT}
									secondary
									style={{ float: "right" }}
									icon={<i className="fa fa-remove" />}
									disabled={this.state.reviewing}
									onClick={() => this.handleReview("reject")}
								/>
								<div style={{ clear: "both" }} />
							</div>
						}
						<Paper style={{ overflowY: "auto", height: this.props.paperHeight, marginLeft: 45, marginTop: 45, width: 1060, display: "inline-block", textAlign: "left", position: "relative" }}>
							<LocationExceptionInfo
								exception={this.state.locationException}
								record={this.state.exceptionRecord.Record}
							/>
							{this.state.locationException.TypeEnum === EExceptionType.LOCATION &&
								<div style={{ width: "100%", height: 275 }}>
									<NearLocationsPunchMap
										record={this.state.exceptionRecord.Record}
									/>
								</div>
							}
						</Paper>
					</div>
				}
			</div>
		)
	}
}
